import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import { parseCapacityManagementActualHoursPayload } from '../payloads/capacityManagementActualHoursPayload';

export const buildCapacityManagementActualHoursInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseCapacityManagementActualHoursPayload(payload);
  const aggregate = parsedPayload.data.attributes.aggregate;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: aggregate.total_actual_hours.current ?? 0,
          trend: aggregate.total_actual_hours.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
